import lineMultiLine from "assets/images/chart-images/multi-line.png";
import barClusteredBarChart from "assets/images/chart-images/clustered-bar-chart.png";
import barHorizontalStackedBar from "assets/images/chart-images/horizontal-stacked-bar.png";
import barStachedBar from "assets/images/chart-images/stacked-bar.png";
import barStacked100Bar from "assets/images/chart-images/100-stacked-bar.png";
import table from "assets/images/chart-images/table.png";

const timePeriodList = [
        { id: "DIdTPDT-BVS01p", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DIdTPDT-BVS02p", name: "100%-stacked-bar", chartImage: barStacked100Bar, disabled: false },
        { id: "DIdTPDT-BHS01p", name: "horizontal-stacked-bar", chartImage: barHorizontalStackedBar, disabled: false },
        { id: "DIdTPDT-CC01p", name: "clustered-bar", chartImage: barClusteredBarChart, disabled: false },
        { id: "DIdTPDT-L01p", name: "multi-line", chartImage: lineMultiLine, disabled: false },
        { id: "DIdTPDT-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DIdTPDT-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },

        { id: "DIdCDT-BVS01p", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DIdCDT-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DIdCDT-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },

        { id: "DIdCTDT-BVS01p", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DIdCTDT-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DIdCTDT-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },

        { id: "DIdCTCDT-BVS01p", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DIdCTCDT-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DIdCTCDT-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },
];

export default timePeriodList;

